<template>
    <div ref="brandSection">
        <div class="row">
            <div class="col-sm-12 text-center">
                <h2>gesucht, gefunden.</h2><small>Wählen Sie bitte zuerst Ihre Marke.</small>
            </div>
        </div>
        <div class="row narrow">
            <div class="col-sm-12 brandText">
                Schnellsuche nach marke
            </div>
        </div>
        <br>
        <div class="row">
            <template v-for="brand in brands">
                <div :key="brand.id" class="col-sm-3 col-xs-6">
                    <div :class="[classObject(brand.id), brand.name]" @click="onClick" :data-id="brand.id"></div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                selected: null,
                brands: [
                    {id:3, name:'audi'},
                    {id:4, name:'bmw'},
                    {id:5, name:'mercedes'},
                    {id:6, name:'porsche'}
                ]
            }
        },

        methods: {
            onClick({currentTarget}) {

                this.selected = currentTarget.dataset.id;
                App.event.fire('car.brand.selected', this.selected);

                new Form({id: this.selected})
                    .post('/api/cars')
                    .then((cars) => {
                        App.event.fire('car.brand.loaded', cars);
                    });

            },

            classObject(id) {
                return {
                    'brand-box' : true,
                    'active': (id == this.selected)
                }
            }
        },

        created() {
            App.event.listen('car.selection.loaded', selection => {
                if (selection.cars) {
                    this.selected = Object.keys(selection.cars).pop();
                    let target = $(this.$refs.brandSection);
                    $('html, body').stop().animate({
                        scrollTop: target.offset().top
                    }, 1000); 
                }
            });
        }
    }
</script>